import { render, staticRenderFns } from "./LoyaltyPreview.vue?vue&type=template&id=923e4908&scoped=true&"
import script from "./LoyaltyPreview.vue?vue&type=script&lang=ts&"
export * from "./LoyaltyPreview.vue?vue&type=script&lang=ts&"
import style0 from "./LoyaltyPreview.vue?vue&type=style&index=0&id=923e4908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923e4908",
  null
  
)

export default component.exports